import { TextField } from '@material-ui/core'
import  $http  from '../../../utils/$http'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Autocomplete } from '@material-ui/lab'
import { countries } from '@tfo/common/src/models'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectCountries = observer(
	({ onSelect, hasError, setCountryError}:
		{
			onSelect: (newValue: countries) => void
			setCountryError: (hasError: boolean) => void
			hasError: boolean
		}) => {
		const intl = useIntl()

		const [selectedValue, setSelectedValue] = React.useState([])
		const [countries, setCountries] = React.useState([])

		const intlLabel = intl.formatMessage({ id: 'common.country' })
		React.useEffect(() => {
			getCountries()
		}, [])

		const getCountries = async () => {
			const countries = await $http.get<any>('/order/countries')
			setCountries(countries)
		}

		const onHandleChange = (value: any[]) => {
			setSelectedValue(value as countries)
			onSelect(value as countries)
			setCountryError(value.length < 1)
		}

		return (
			<Autocomplete
				multiple
				id="grouped-demo"
				options={countries}
				value={selectedValue}
				onChange={(event, newValue: any[]) => {
					onHandleChange(newValue)
				}}
				disableCloseOnSelect
				groupBy={option => option.region}
				getOptionLabel={option => option.country}
				renderOption={(option, { selected }) => (
					<React.Fragment>
						<Checkbox
							icon={icon}
							checkedIcon={checkedIcon}
							style={{ marginRight: 8 }}
							checked={selected}
						/>
						{option.country}
					</React.Fragment>
				)}
				renderInput={params => (					
					<TextField
						{...params}
						className={hasError ? '--hasError' : ''}
						error={hasError}
						variant="outlined"
						label={intlLabel}
						fullWidth
					/>
				)}
			/>
		)
	},
)

export default SelectCountries
